import { API_NAME } from './constants';

export const mapDomainToAPIEndpoint = (domain) => {
  const bingAdsDomains = ['adlibrary.ads.microsoft.com', 'adlibraryui-test.azureedge.net'];
  if (bingAdsDomains.includes(domain)) {
    return 'https://adlibrary.api.bingads.microsoft.com';
  }
  return 'https://adlibrary-si.corp.microsoft.com';
};

export const getApiNameFromUrl = (fullUrl) => {
  const mainPart = fullUrl.split('/api/v1/')[1].split('?')[0];
  /**
   * 1. /Ads                        ->  getAds
   * 2. /Ads/<Id>?                  ->  getAdDetail
   * 3. /Advertisers                ->  getAdvertisers
   * 4. /Advertisers/<id>?          ->  getAdvertiserDetail
   */
  if (/^Ads$/.test(mainPart)) {
    return API_NAME.GET_ADS;
  } else if (/^Ads\/[^d]+\/?$/.test(mainPart)) {
    return API_NAME.GET_AD_DETAIL;
  } else if (/^Advertisers$/.test(mainPart)) {
    return API_NAME.GET_ADVERTISERS;
  } else if (/^Advertisers\/[^/]+\/?$/.test(mainPart)) {
    return API_NAME.GET_ADVERTISER_DETAIL;
  }
  return API_NAME.UNKNOWN;
};

export const getReqIdFromRoute = (route) => {
  const reqIdQueryString = route.split('&').find(param => param.includes('ReqId'));
  if (!reqIdQueryString) return null;
  return reqIdQueryString.split('=')[1];
};
